<template>
    <div class="row wrap">
        <div class="col-6">
            <input-text v-model="label.x_coord" :label="$t('Coord X')" after="px" @change="label.save()"/>
        </div>
        <div class="col-6">
            <input-text v-model="label.y_coord" :label="$t('Coord Y')" after="px" @change="label.save()"/>
        </div>
        <div class="col-12">
            <input-media v-model="label.image" :label="$t('Image')"  :storie-id="label.getStoryId()" @change="label.save()"/>
        </div>
        <div class="col-6">
            <input-text v-model="label.diameter" :label="$t('Diameter')" after="px" @change="label.save()"/>
        </div>
        <div class="col-12">
            <Pointer_Edit :label="label"></Pointer_Edit>
        </div>
    </div>
</template>

<script>
    import InputText from "@/modules/input/input-text";
    import Pointer_Edit from "@/modules/labels/Pointer_Edit";
    import InputMedia from "@/modules/input/input-media";

    export default {
        name: "XRays_Edit",
        components: {InputMedia, Pointer_Edit, InputText},
        props:{
            label:{}
        },
    }
</script>

<style scoped>

</style>